import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './index.css'

// Register service worker for caching — PRODUCTION ONLY.
// In dev the SW's cache-first strategy hijacks Vite's modules and serves stale
// chunks, which breaks HMR and can cause "Invalid hook call" from mismatched
// cached React copies. Keep it disabled during development.
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {
      // Service worker registration failed, but app still works
      console.log('Service worker not available')
    })
  })
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
